import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-51d25737-83dd-4163-b670-8c59d5b385ec-__Outline",
  height: "512",
  viewBox: "0 0 128 128",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", { d: "m122.701 62.717c-1.07-1.278-26.564-31.299-58.702-31.299-32.136 0-57.63 30.021-58.7 31.299-.621.742-.621 1.824 0 2.566 1.07 1.278 26.564 31.299 58.7 31.299 32.138 0 57.632-30.021 58.702-31.299.621-.742.621-1.824 0-2.566zm-58.702 29.865c-26.596 0-49.239-22.859-54.489-28.582 5.25-5.723 27.894-28.582 54.489-28.582 26.6 0 49.244 22.862 54.492 28.583-5.243 5.723-27.86 28.581-54.492 28.581z" }),
      _createElementVNode("path", { d: "m64 44.717c-10.634 0-19.284 8.65-19.284 19.283s8.65 19.283 19.284 19.283c10.633 0 19.283-8.65 19.283-19.283s-8.65-19.283-19.283-19.283zm0 34.566c-8.428 0-15.284-6.856-15.284-15.283s6.856-15.283 15.284-15.283c8.427 0 15.283 6.856 15.283 15.283s-6.856 15.283-15.283 15.283z" })
    ], -1)
  ]))]))
}
export default { render: render }